import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadEvent, LocalLoadEventStatus, LocalLoadEventType } from '../../shared/local-load-event.model';

@Component({
  selector: 'app-load-events',
  templateUrl: './load-events.component.html',
  styleUrls: ['./load-events.component.scss']
})
export class LoadEventsComponent implements OnInit {

  @Input()
  events: LocalLoadEvent[] = [];

  EventTypes = LocalLoadEventType;

  EventStatus = LocalLoadEventStatus;

  expanded = true;

  constructor() {
  }

  ngOnInit() {
  }

  expand() {
    this.expanded = !this.expanded;
  }

}
